import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"guitar"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M8 22C11.3137 22 14 19.3137 14 16C14 15.6238 13.9654 15.2556 13.8991 14.8985C15.6753 14.4906 17 12.9 17 11C17 9.89542 16.5523 8.8954 15.8284 8.17154C15.1045 7.4477 14.1046 7 13 7C11.1 7 9.50943 8.3247 9.10145 10.1009C8.7444 10.0346 8.37624 10 8 10C4.68629 10 2 12.6863 2 16C2 19.3137 4.68629 22 8 22Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M10 16C10 17.1046 9.10457 18 8 18C6.89543 18 6 17.1046 6 16C6 14.8954 6.89543 14 8 14C8.55228 14 9.05228 14.2239 9.41421 14.5858C9.77614 14.9477 10 15.4477 10 16Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15.8281 8.17154L19.9997 4M19 3L21 5M17.5 5.5L18.5 6.5M14 16C14 19.3137 11.3137 22 8 22C4.68629 22 2 19.3137 2 16C2 12.6863 4.68629 10 8 10C8.37624 10 8.7444 10.0346 9.10145 10.1009C9.50943 8.3247 11.1 7 13 7C14.1046 7 15.1045 7.4477 15.8284 8.17154C16.5523 8.8954 17 9.89542 17 11C17 12.9 15.6753 14.4906 13.8991 14.8985C13.9654 15.2556 14 15.6238 14 16Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M10 16C10 17.1046 9.10457 18 8 18C6.89543 18 6 17.1046 6 16C6 14.8954 6.89543 14 8 14C8.55228 14 9.05228 14.2239 9.41421 14.5858C9.77614 14.9477 10 15.4477 10 16Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Guitar = Vue.extend<IconProps>({
  name: 'GuitarIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'guitar',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Guitar;
